import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when geofencing process is being initialized.
 * @memberOf Playtech.API.events
 * @event geofencing-init
 * @type {callback}
 * @param {object} detials
 * @param {number} details.geolocationType - Provider used.
 * @example Playtech.on('geofencing-init', ({ geolocationType }) => { ... });
 */
export const GEOFENCING_INIT = 'geofencing-init';

export const useOnGeofencingInit = (eventTarget: EventTarget): void => {
    const triggerGeofencingInitEvent = useCallback((detail: {
        geolocationType: string;
    }) => {
        const event = new CustomEvent(GEOFENCING_INIT, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('geofencing-init', triggerGeofencingInitEvent);

        return () => {
            publicEventsAPIService.off('geofencing-init', triggerGeofencingInitEvent);
        };
    }, [triggerGeofencingInitEvent]);
};
